export type QualityTier = 'still' | 'low' | 'balanced' | 'high'

export interface RenderQuality {
  tier: QualityTier
  dpr: number
  particles: number
  shadows: boolean
}

export function chooseRenderQuality(
  width: number,
  devicePixelRatio: number,
  reducedMotion: boolean,
  webglAvailable = true,
): RenderQuality {
  if (!webglAvailable || reducedMotion) {
    return { tier: 'still', dpr: 1, particles: 0, shadows: false }
  }

  if (width < 520) {
    return {
      tier: 'low',
      dpr: Math.min(devicePixelRatio, 1.2),
      particles: 70,
      shadows: false,
    }
  }

  if (width < 1100) {
    return {
      tier: 'balanced',
      dpr: Math.min(devicePixelRatio, 1.35),
      particles: 120,
      shadows: true,
    }
  }

  return {
    tier: 'high',
    dpr: Math.min(devicePixelRatio, 1.75),
    particles: 180,
    shadows: true,
  }
}

export function hasWebGL(): boolean {
  try {
    const canvas = document.createElement('canvas')
    return Boolean(canvas.getContext('webgl2'))
  } catch {
    return false
  }
}

export function normalizeAppStoreUrl(value?: string): string | null {
  if (!value) return null
  try {
    const url = new URL(value)
    return url.protocol === 'https:' && url.hostname === 'apps.apple.com' ? url.toString() : null
  } catch {
    return null
  }
}
